import React from 'react';
import { Stack, Box, ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

const GridContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '12px',
  justifyContent: 'flex-start',
  marginBottom: '16px',
  overflowX: 'auto',
  overflowY: 'hidden',
  width: '100%',
  padding: '4px 0 8px',
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  [theme.breakpoints.up('sm')]: {
    gap: '16px',
    justifyContent: 'center',
    marginBottom: '20px',
    overflowX: 'visible',
    flexWrap: 'wrap'
  },
  [theme.breakpoints.up('md')]: {
    gap: '20px',
    marginBottom: '24px'
  }
}));

const TemplateCard = styled(ButtonBase)(({ theme, selected }) => ({
  width: '80px',
  height: '80px',
  minWidth: '80px',
  border: selected ? '3px solid #0B91D6' : '2px solid #E0E0E0',
  borderRadius: '8px',
  overflow: 'hidden',
  transition: 'all 0.2s ease',
  WebkitTapHighlightColor: 'transparent',
  '&:active': {
    transform: 'scale(0.95)'
  },
  [theme.breakpoints.up('sm')]: {
    width: '100px',
    height: '100px',
    minWidth: '100px',
    borderRadius: '10px'
  },
  [theme.breakpoints.up('md')]: {
    width: '120px',
    height: '120px',
    minWidth: '120px',
    '&:hover': {
      borderColor: '#0B91D6',
      transform: 'scale(1.02)'
    },
    '&:active': {
      transform: 'scale(1)'
    }
  }
}));

const TemplateImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover'
}));

const TemplatePreviewGrid = ({ templates, selectedTemplateId, onTemplateSelect }) => {
  return (
    <GridContainer>
      {templates.map((template) => (
        <TemplateCard
          key={template.id}
          selected={selectedTemplateId === template.id}
          onClick={() => onTemplateSelect(template.id)}
        >
          <TemplateImage 
            src={template.thumbnail} 
            alt={`Template ${template.id}`}
          />
        </TemplateCard>
      ))}
    </GridContainer>
  );
};

export default TemplatePreviewGrid;
